/* eslint-disable jsx-a11y/click-events-have-key-events */
import { css } from '@emotion/css';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { ReactComponent as Check } from '../../assets/images/check.svg';

export const LanguageCell: React.FC<{
  label: string;
  language: string;
  onClick: () => void;
  isChecked?: boolean;
  isSelected?: boolean;
}> = ({ label, language, onClick, isChecked, isSelected }) => {
  const { t } = useTranslation('settings');
  return (
    <li
      className={css`
        width: 100%;
        padding: 2px 0 0;
        position: relative;
        &:nth-child(n + 2)::after {
          content: '';
          position: absolute;
          top: 0;
          right: 16px;
          left: 16px;
          border-bottom: 2px dashed #dcd8bf;
        }
      `}
      onClick={onClick}
      role="option"
      aria-selected={isChecked}
    >
      <div
        className={css`
          display: flex;
          border-radius: 2px;
          padding: 12px 32px;
          color: #4d3906;
          transition: background 0.2s;
          &:active {
            background: #ece5d4;
          }
          .lang {
            flex: 1 1 auto;
            display: flex;
            flex-direction: column;
            align-items: left;
            align-items: start;
          }
          .lang .tran {
            display: block;
            font-size: 11px;
          }
          .check {
            flex: 0 0 auto;
            display: flex;
            justify-content: center;
            align-items: center;
            width: 40px;
            height: 40px;
            opacity: ${isChecked ? 1 : 0.3};
            visibility: ${isChecked || isSelected ? 'visible' : 'hidden'};
            transform: ${isChecked || isSelected ? 'scale(1)' : 'scale(0)'};
            transition: all 0.2s;
          }
        `}
      >
        <div className="lang">
          <span className="label">{label}</span>
          <span className="tran">{t(language)}</span>
        </div>
        <span className="check">
          <Check />
        </span>
      </div>
    </li>
  );
};
